import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllSponsor } from '../../store/sponsor'

import { sponsorExportColumns } from '../../config/exportColumns/sponsorExportColumns'
import { useDispatch } from 'react-redux'

function Sponsor() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Sponsors and advertisements</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllSponsor({ ...params, loading: false }))}
							filters={{}}
							columns={sponsorExportColumns}
							fileName="Sponsors"
							sheetName="Sponsor List"
							buttonText="Export Sponsors and advertisements"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/sponsor/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Sponsor
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Sponsor
